import Marquee from "react-fast-marquee";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { useEffect } from "react";
import { Link } from 'react-router-dom';

export default function AboutUs(props) {
  useEffect(() => {
    document.title = props.title;
  }, [props.title]);

  const logos = [
    "assets/img/Amazon_logo.png",
    "assets/img/ibm-logo.png",
    "assets/img/Infosys_logo.png",
    "assets/img/Oracle_logo.png",
    "assets/img/TCS-logo.png"
  ];

  return (
    <div className="bg-[#f9f8f8]">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 gradient-hero">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
            <div>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 rounded-full border-2 border-[#614a4433] text-sm font-medium text-[#453f3d] mb-6">
                <span className="w-2 h-2 bg-[#156cc2] rounded-full"></span>
                About Us
              </span>
              <h1 className="text-4xl lg:text-5xl font-bold text-[#1a1615] font-display tracking-tight leading-tight mb-6">
                Your partner in building exceptional teams
              </h1>
              <p className="text-lg text-[#453f3d] leading-relaxed">
                Easy Hiring is an IT Services and Talent Outsourcing company
                with a strong in-house talent pipeline.
              </p>
            </div>

            <div className="relative">
              <div className="bg-white rounded-[20px] overflow-hidden border-2 border-[#614a4433] shadow-[0_4px_50px_#614a440f]">
                <img
                  className="w-full h-full object-cover"
                  src="assets/img/3z_marketing_5.png"
                  alt="About Us"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-[#156cc2] rounded-[16px] -z-10"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20 bg-[#f4f1ee]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full border-2 border-[#614a4433] text-sm font-medium text-[#453f3d] mb-6">
              <span className="w-2 h-2 bg-[#cf8d13] rounded-full"></span>
              Our Story
            </span>
            <p className="text-xl text-[#453f3d] leading-relaxed">
              We collaborate with colleges and external candidates to train them
              on industry-relevant technologies, then deploy them to clients as
              dedicated engineers or complete project teams. Our engineers work
              on client projects while staying on our payroll — giving businesses
              flexibility, quality talent, and delivery ownership without the overhead.
            </p>
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="py-16 bg-gradient-to-r from-[#84b9ef] to-[#156cc2]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { end: 50, suffix: "+", label: "Engineers Deployed" },
              { end: 20, suffix: "+", label: "Client Companies" },
              { end: 30, suffix: "+", label: "Projects Delivered" },
              { end: 15, suffix: "+", label: "Technologies" }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">
                  <CountUp
                    end={stat.end}
                    redraw={true}
                    suffix={stat.suffix}
                    scrollSpyOnce={true}
                  >
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </div>
                <p className="text-white/80 text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative order-2 lg:order-1">
              <div className="bg-white rounded-[20px] overflow-hidden border-2 border-[#614a4433] shadow-[0_4px_50px_#614a440f]">
                <img
                  className="w-full h-full object-cover"
                  src="assets/img/clip-financial-report.gif"
                  alt="Our Mission"
                />
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#f4f1ee] rounded-full border-2 border-[#614a4433] text-sm font-medium text-[#453f3d] mb-6">
                <span className="w-2 h-2 bg-[#156cc2] rounded-full"></span>
                Our Mission
              </span>
              <h2 className="text-3xl lg:text-4xl font-bold text-[#1a1615] font-display tracking-tight leading-tight mb-6">
                Democratizing access to quality talent
              </h2>
              <p className="text-[#453f3d] leading-relaxed mb-4">
                At Easy Hiring, we believe every business deserves access to
                quality engineering talent without the complexity of traditional
                hiring. We train engineers in industry-relevant technologies —
                AI/ML, Full Stack, Data Engineering, Automation Testing, Salesforce,
                and Business Analysis — then deploy them to clients who need to
                scale fast.
              </p>
              <p className="text-[#453f3d] leading-relaxed">
                Our model is simple: you get the talent, we handle
                the rest. From payroll to performance management, we act as your
                extended engineering arm.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Client Logos */}
      <section className="py-16 bg-[#f4f1ee] border-y-2 border-[#614a4433]">
        <div className="max-w-6xl mx-auto px-6">
          <p className="text-center text-sm font-medium text-[#7a7270] uppercase tracking-wider mb-10">
            Trusted by industry leaders
          </p>
          <div className="relative w-full overflow-hidden">
            <Marquee 
              gradient={false} 
              speed={40} 
              pauseOnHover={true}
              className="flex items-center"
            >
              {[...logos, ...logos, ...logos].map((logo, index) => (
                <div key={index} className="mx-12 opacity-50 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0">
                  <img
                    className="max-h-8 w-auto object-contain"
                    src={logo}
                    alt="Client Logo"
                  />
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#f4f1ee] rounded-full border-2 border-[#614a4433] text-sm font-medium text-[#453f3d] mb-6">
              <span className="w-2 h-2 bg-[#cf8d13] rounded-full"></span>
              Our Values
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#1a1615] font-display tracking-tight">
              What drives us
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                num: "01",
                title: "Quality First",
                description: "We never compromise on the quality of talent we deploy. Every engineer goes through rigorous training and assessment.",
                color: "#156cc2"
              },
              {
                num: "02",
                title: "Client Success",
                description: "Your success is our success. We take complete ownership of delivery and ensure our engineers meet your expectations.",
                color: "#cf8d13"
              },
              {
                num: "03",
                title: "Continuous Learning",
                description: "Technology evolves fast. We continuously upskill our engineers to stay current with industry demands.",
                color: "#84b9ef"
              }
            ].map((value, index) => (
              <div
                key={index}
                className="group p-8 bg-white rounded-[20px] border-2 border-[#614a4433] shadow-[0_4px_50px_#614a440f] hover:shadow-[0_8px_60px_#614a4420] hover:-translate-y-1 transition-all duration-300"
              >
                <span
                  className="inline-flex items-center justify-center w-10 h-10 rounded-full text-white text-sm font-bold mb-6"
                  style={{ backgroundColor: value.color }}
                >
                  {value.num}
                </span>
                <h3 className="text-xl font-semibold text-[#1a1615] mb-4">
                  {value.title}
                </h3>
                <p className="text-[#453f3d] leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#f4f1ee]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-gradient-to-r from-[#84b9ef] to-[#156cc2] rounded-[24px] p-12 lg:p-16 text-center">
            <h2 className="text-3xl lg:text-4xl font-bold text-white font-display tracking-tight mb-6">
              Ready to build your team?
            </h2>
            <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
              Let's discuss how we can help you scale your engineering capacity.
            </p>
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 px-8 py-4 bg-white text-[#156cc2] font-semibold rounded-full hover:shadow-lg transition-all duration-300"
            >
              Get started
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
